<template>
  <div class="main">
    <div class="titlechecked">
      <span @click="changeIndex(0)" :class="{active:isActive0}">
        <em class="titck0"></em>
        {{$t('global.主持团')}}
      </span>
      <span @click="changeIndex(1)" :class="{active:isActive1}">
        <em class="titck1"></em>
        {{$t('global.达人')}}
      </span>
      <span @click="changeIndex(2)" :class="{active:isActive2}">
        <em class="titck2"></em>
        {{$t('global.成员')}}
      </span>
    </div>
    <div class="middle">
      <div class="member-list" v-if="listLength > 0">
        <el-col :span="12" v-for="(item,index) in list" :key="index">
          <div class="member-item">
            <router-link target="_blank" :to="'/peopleCenter/'+item.userId">
              <img class="member-img" v-if="item.avatar" :src="item.avatar | imageUrl('/static/profile_img_default.png', 75, 75)" />
              <img class="member-img" v-else src="/static/profile_img_default.png" />
            </router-link>
            <div class="member-content">
              <div class="member-name">
                <router-link
                  target="_blank"
                  :to="'/peopleCenter/'+item.userId"
                >{{item.nickName}}</router-link>
              </div>
              <div class="author-title">
                {{item.country}}
                <b v-if="item.country || item.area">,</b>
                {{item.area}}
              </div>
              <div class="majiang">
                <router-link :to="'/peopleCenter/'+item.userId">
                  <span>{{$t('global.粉丝')}}</span>
                  <b>{{item.fansCount}}</b>
                </router-link>
                <router-link :to="'/peopleCenter/'+item.userId+'/video'">
                  <span>{{$t('global.作品')}}</span>
                  <b>{{item.videoCount}}</b>
                </router-link>
              </div>
              <p>{{item.introduce}}</p>
              <div class="member-bottom">
                <button
                  class="member-focus"
                  v-bind:class="{following: item.isFollow==1}"
                  @click="Follow(item)"
                >{{!item.isFollow?$t('global.关注'):$t('global.取消关注')}}</button>
              </div>
            </div>
          </div>

          <div class="memberightside">
            <ul>
              <li v-for="video in item.videoList" :key="video.id">
                <router-link :to="'/video/detail?id='+video.id">
                  <img :src="video.thumb | imageUrl('', 226, 128)" />
                  <p>{{video.title}}</p>
                </router-link>
              </li>
            </ul>
          </div>
        </el-col>
      </div>
      <content-empty v-else-if="listLength == 0" :content="$t('global.没有成员')"></content-empty>
      <pages
        :page-size="pagerParam.pageSize"
        :page-count="pagerParam.pageCount"
        :current-page="pagerParam.currentPage"
        :total="pagerParam.total"
        @current-page-changed="OnCurrentPageChanged"
      ></pages>
    </div>
  </div>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import pages from "../../components/pages.vue";
import ContentEmpty from "../../components/ContentEmpty";
export default {
  name: "SubjectDetail",
  components: {
    MainLayout,
    pages,
    ContentEmpty
  },
  data() {
    return {
      filterSelected: 1,
      filterSearchContent: "",
      detail: {},
      list: [],
      listLength: -1,
      pagerParam: {
        pageSize: 9,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      activeIndex: 0,
      isActive0: true,
      isActive1: false,
      isActive2: false,
      roleIds: "1,2"
    };
  },
  props: ["index"],
  created() {
    if (this.index != null) {
      this.changeIndex(this.index);
    } else {
      this.changeIndex(0);
    }
  },
  methods: {
    changeIndex(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.isActive0 = true;
          this.isActive1 = false;
          this.isActive2 = false;
          this.roleIds = "1,2";
          break;
        case 1:
          this.isActive0 = false;
          this.isActive1 = true;
          this.isActive2 = false;
          this.roleIds = "3";
          break;
        case 2:
          this.isActive0 = false;
          this.isActive1 = false;
          this.isActive2 = true;
          this.roleIds = "0";
          break;
      }
      this.GetData();
    },
    Follow(item) {
      let that = this;
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
        return;
      }
      this.$http
        .post(
          `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
            item.userId
          }`
        )
        .then(function(response) {
          if (response) {
            item.isFollow = !item.isFollow;
            if (item.isFollow) {
              that.$message.success(response.message);
            } else {
              that.$message(response.message);
            }
          }
        });
    },
    GetData() {
      var $this = this;
      let url = "";
      if (this.roleIds == 0) {
        url = `/api/topic/getMemberListByParms?topicId=${$this.$query.id}&keyword${$this.filterSearchContent}
              &type=1&indexOf=1&isSl=1&roleIds=${this.roleIds}&orderBy=1&pageIndex=${this.pagerParam.currentPage}&pageSize=${this.pagerParam.pageSize}`;
      } else {
        url = `/api/topic/getMemberListByParms?topicId=${$this.$query.id}&keyword=${$this.filterSearchContent}
        &type=1&indexOf=1&isSl=1&roleIds=${this.roleIds}&orderBy=0&pageIndex=${this.pagerParam.currentPage}&pageSize=${this.pagerParam.pageSize}`;
      }

      $this.$http.get(url).then(function(response) {
        if (response.data) {
          $this.list = response.data.list;
          $this.pagerParam = {
            pageSize: 9,
            pageCount: response.data.totalPage,
            currentPage: response.data.pageIndex,
            total: response.data.totalRecord
          };
          $this.listLength = $this.list.length;
        }
      });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      switch (this.activeIndex) {
        case 0:
          this.roleIds = "1,2";
          break;
        case 1:
          this.roleIds = "3";
          break;
        case 2:
          this.roleIds = "0";
          break;
      }
      this.GetData();
    }
  },
  watch: {
    filterSelected: function() {
      this.GetData();
    },
    childIndex(newVal, oldVal) {
      this.changeIndex(newVal);
    }
  }
};
</script>

<style scoped>
a {
  color: #333;
}
.titlechecked {
  color: #999;
  height: 25px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  line-height: 25px;
  margin-top: 30px;
  color: rgba(153, 153, 153, 1);
}
.titlechecked span {
  display: inline-block;
  margin-right: 30px;
}
.titlechecked em {
  display: inline-block;
  width: 27px;
  height: 25px;
}
.titlechecked .titck0 {
  background: url("/static/sample/titck0.jpg") no-repeat;
  background-size: cover;
  vertical-align: middle;
}
.titlechecked .titck1 {
  background: url("/static/sample/titck1.jpg") no-repeat;
  background-size: cover;
  vertical-align: middle;
}
.titlechecked .titck2 {
  background: url("/static/sample/titck2.jpg") no-repeat;
  background-size: cover;
  vertical-align: middle;
}
.titlechecked .active {
  color: #447bf9;
}
.titlechecked .active .titck0 {
  background: url("/static/sample/titck00.jpg") no-repeat;
  background-size: cover;
  vertical-align: middle;
}
.titlechecked .active .titck1 {
  background: url("/static/sample/titck11.jpg") no-repeat;
  background-size: cover;
  vertical-align: middle;
}
.titlechecked .active .titck2 {
  background: url("/static/sample/titck22.jpg") no-repeat;
  background-size: cover;
  vertical-align: middle;
}

.member-list .el-col-12 {
  width: 1160px;
  padding: 0 10px 20px 0;
  border-bottom: 1px solid #edecf1;
  margin-bottom: 20px;
}
.member-list .el-col-12 .member-item {
  float: left;
  width: 380px;
}
.member-item .member-content {
  width: 245px;
}
.memberightside {
  float: right;
  width: 472px;
}
.memberightside li {
  float: left;
  width: calc((100% - 20px) / 2);
  margin-right: 20px;
}
.memberightside li:nth-child(2n) {
  margin-right: 0;
}
.memberightside li img {
  width: 226px;
  height: 128px;
  border-radius: 5px;
}
.memberightside li p {
  color: #333;
  fong-size: 14px;
  line-height: 20px;
  height: 43px;
  font-weight: 600;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.banner {
  height: 6rem;
  width: 100%;
  display: block;
  background: no-repeat center center;
  background-size: cover;
}
.main {
  overflow: hidden;
  zoom: 1;
}
.left {
  width: 12rem;
  float: left;
}
.filter-block {
  margin-top: 0.4rem;
  -webkit-border-radius: 6px 6px 0 0;
  -moz-border-radius: 6px 6px 0 0;
  border-radius: 6px 6px 0 0;
  background-color: #fff;
  padding: 0.33rem 0.4rem 0.3rem;
  box-sizing: border-box;
  font-size: 0.2rem;
  color: #777;
  position: relative;
  height: 0.87rem;
  overflow: hidden;
}
.filter-title {
  padding-right: 0.55rem;
  border-right: 2px solid #ebebeb;
  display: inline-block;
  vertical-align: middle;
}
.filter-item {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.3rem 0 0.5rem;
  cursor: pointer;
  position: relative;
}
.filter-item.active {
  color: #333;
}
.filter-item.active:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.28rem;
  height: 0.03rem;
  background-color: #333;
  display: block;
}
.filter-search {
  position: absolute;
  right: 0.4rem;
  top: 0.2rem;
}
.txt-search {
  width: 4rem;
  height: 0.46rem;
  border: 2px solid #0060ff;
  padding: 0 0.2rem;
  -webkit-border-radius: 0.23rem;
  -moz-border-radius: 0.23rem;
  border-radius: 0.23rem;
  outline: none;
  font-size: 0.16rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  vertical-align: middle;
  color: #0060ff;
}

.icon-search {
  display: inline-block;
  width: 0.24rem;
  height: 0.24rem;
  color: #0060ff;
  margin-left: -0.44rem;
  vertical-align: middle;
  cursor: pointer;
}

.middle {
  background-color: #fff;
  margin-top: 0.2rem;
  margin-bottom: 0.8rem;
  overflow: hidden;
  zoom: 1;
  position: relative;
  clear: both;
  border-radius: 0 0 6px 6px;
}
.member-list {
  overflow: hidden;
  zoom: 1;
}
.member-item {
  padding: 0.4rem 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  zoom: 1;
}
.member-img {
  float: left;
  display: block;
  width: 75px;
  height: 75px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.member-content {
  float: left;
  margin-left: 0.3rem;
  width: 4rem;
}
.member-name {
  font-size: 16px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
}
.member-title {
  font-size: 0.16rem;
  color: #777;
  margin: 0.1rem 0 0.2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.member-focus {
  display: block;
  font-size: 0.16rem;
  color: #fff;
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  padding: 0;
  margin-top: 10px;
  vertical-align: middle;
  border-radius: 2px;
  background-color: #0060ff;
}
.member-focus.following {
  background: #ddd;
}
.member-time {
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
}
.member-bottom {
  margin-top: 0.1rem;
}
.author-title {
  font-size: 0.17rem;
  color: #777777;
  margin-top: 0.06rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.author-title > strong {
  color: #000;
}
.right {
  width: 3.8rem;
  margin-left: 0.2rem;
  float: left;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.right-1 {
  margin-top: 0.4rem;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 0.3rem 0.25rem 0.4rem;
}
.right-title {
  font-size: 0.18rem;
  color: #333333;
  font-weight: bold;
  margin-left: -0.25rem;
  padding-left: 0.25rem;
  position: relative;
  margin-bottom: 0.25rem;
}
.right-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.03rem;
  display: block;
  width: 0.06rem;
  height: 0.19rem;
  background-color: #0161ff;
  -webkit-border-radius: 0.03rem;
  -moz-border-radius: 0.03rem;
  border-radius: 0.03rem;
  margin-bottom: 0.3rem;
}
.right-subject-title {
  font-size: 0.22rem;
  color: #333;
  font-weight: bold;
}
.right-count {
  font-size: 0.14rem;
  color: #999999;
  margin: 0.07rem 0 0.12rem;
}
.right-cat {
  font-size: 0.16rem;
  color: #777777;
  margin-bottom: 0.19rem;
}
.right-author {
  line-height: 0.5rem;
  height: 0.5rem;
}
.right-author-avatar {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.2rem;
  float: left;
}
.right-author-name {
  font-size: 0.2rem;
  color: #333333;
  float: left;
}
.right-author-time {
  font-size: 0.18rem;
  color: #777;
  float: right;
}
.right-content {
  clear: both;
  font-size: 0.16rem;
  color: #777777;
  line-height: 0.3rem;
  position: relative;
}
.right-content-content {
  min-height: 0.2rem;
  display: block;
}
.right-subject-title {
  font-size: 0.22rem;
  color: #333;
  font-weight: bold;
}
.right-subject-content {
  font-size: 0.14rem;
  color: #999;
}
.right-subject-content span {
  color: #0060ff;
  display: inline-block;
  border-bottom: 1px solid #0060ff;
  margin-top: 0.05rem;
}
.right-subject-thumb {
  width: 3.3rem;
  height: 1.88rem;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  display: block;
  margin-top: 0.25rem;
}
.right-collapse {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.16rem;
  color: #0060ff;
  cursor: pointer;
}
.right-1-btn {
  width: 1.8rem;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0;
  display: block;
  -webkit-border-radius: 0.2rem;
  -moz-border-radius: 0.2rem;
  border-radius: 0.2rem;
  border: none;
  background-color: #0060ff;
  color: #fff;
  font-size: 0.16rem;
  font-weight: bold;
  text-align: center;
  margin: 0.2rem auto 0;
}
.right-2 {
  margin-top: 0.2rem;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 0.3rem 0.25rem 0.2rem;
}
.right-sum {
  font-size: 0.2rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.6rem;
  position: relative;
  cursor: pointer;
  margin: 0 -0.25rem;
  padding: 0 0.25rem;
}
.right-sum span {
  position: absolute;
  right: 0;
  top: 0.2rem;
}
.right-sum.active {
  background-color: #0060ff;
  color: #fff;
}
.txt-search::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #0060ff;
}

.txt-search:-moz-placeholder,
textarea:-moz-placeholder {
  color: #0060ff;
}

.txt-search::-moz-placeholder,
textarea::-moz-placeholder {
  color: #0060ff;
}

.txt-search:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #0060ff;
}
.majiang {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}
.majiang a {
  color: #999;
  font-size: 12px;
}
.majiang a b {
  color: #000;
  margin: 0 13px 0 6px;
}
.majiang + p {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/subject/SubjectMember1.vue